function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M24,0H0V24H24M19.8,12A7.8,7.8,0,1,1,12,4.2,7.8,7.8,0,0,1,19.8,12Z",
    style: {
      "fill": "#969b9d"
    }
  }), React.createElement("path", {
    d: "M16.69,11.06a13.07,13.07,0,0,0-9.11-.91.73.73,0,1,1-.49-1.37h.07a14.46,14.46,0,0,1,10.28,1,.72.72,0,0,1,.26,1h0A.74.74,0,0,1,16.69,11.06Z",
    style: {
      "fill": "#969b9d",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M16.6,13.28a.63.63,0,0,1-.83.2h0A10.21,10.21,0,0,0,8,12.59.62.62,0,0,1,7.6,11.4h0a11.44,11.44,0,0,1,8.81,1A.62.62,0,0,1,16.6,13.28Z",
    style: {
      "fill": "#969b9d",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M15.65,15.42a.49.49,0,0,1-.67.16h0a8.87,8.87,0,0,0-6.86-.76.48.48,0,0,1-.58-.36.49.49,0,0,1,.36-.59h0a9.92,9.92,0,0,1,7.61.88.48.48,0,0,1,.18.62Z",
    style: {
      "fill": "#969b9d",
      "fillRule": "evenodd"
    }
  }));
};

export default __webpack_public_path__ + "static/media/spotify.939332dd.svg";
export { SvgComponent as ReactComponent };